<template>
  <div class="main-basic-info">
    <div class="main-basic-info__col">
      <title-and-logo
          class="main-basic-info__section"
          :brand="car.brand"
          :model="car.model"
          :logo="car.logoBrand"
      />
      <basic-info
          class="main-basic-info__section"
          :items="car.basicInfo"
          :loaded="loaded"
      />
      <price-block
          class="main-basic-info__section"
          :propPriceHide="true"
          :propCheckPricee="false"
          :propPrice="car.price"
          :propDiscountPrice="car.oldPrice"
          :propLoaded="loaded"
          :propOldCar="true"
          :isSpecialOffer="car.is_special_price > 0?true:false"
          :car="car"
      />
      <parking-and-description
          v-if="$device.tablet()"
          class="main-basic-info__section mb-0"
          :address="isSold?null:car.parkingAddress"
          :text="isSold?'ATH. ÖKUTÆKI SELD':(car.retailDescription || '')"
          :spot="isSold ? false : car.spot"
          :car="car"
      />
      <company-and-form-btn-block
          v-if="$device.tablet()"
          :loaded="loaded"
          :car="car"
      />
    </div>
    <div class="main-basic-info__col">
      <parking-and-description
          v-if="!$device.tablet()"
          class="main-basic-info__section"
          :address="isSold?null:car.parkingAddress"
          :text="isSold?'ATH. ÖKUTÆKI SELD':(car.retailDescription || '')"
          :spot="isSold ? false : car.spot"
          :car="car"
      />

      <company-and-form-btn-block
          v-if="!$device.tablet()"
          :loaded="loaded"
          :car="car"
      />

      <ad-car  class="ad-car-block" v-if="$device.tablet() && ad" :ad="ad"/>
    </div>
  </div>
</template>

<script>
import TitleAndLogo from "@/components/OldCars/CarSideInfo/TitleAndLogo"
import BasicInfo from "@/components/OldCars/CarSideInfo/BasicInfo"
import ParkingAndDescription from "@/components/OldCars/CarSideInfo/ParkingAndDescription"
import PriceBlock from "@/components/Dealers/PriceBlock"

import CompanyAndFormBtnBlock from "@/components/global/CompanyAndFormBtnBlock"
import adCar from "@/components/global/AdCar";
import CarPageAd from "@/components/global/CarPageAd";

export default {
  components: {
    CompanyAndFormBtnBlock,
    TitleAndLogo,
    BasicInfo,
    PriceBlock,
    ParkingAndDescription,
    adCar,
    CarPageAd
  },
  computed: {
    isSold() {
      return this.car.deleted == 1 ? true : false
    }
  },
  props: {
    car: {
      type: Object,
      default: () => ({
        deleted: false,
        brand: "",
        model: "",
        logoBrand: "",
        transmition: "",
        price: 0,
        oldPrice: 0,
        basicInfo: [],
        retailDescription: "",
        parkingAddress: ""
      })
    },
    loaded: {
      type: Boolean,
      default: false
    },
    ad: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
